<div class="wrapper" #wrapperElement (pointerdown)="onPointerDown($event)">
  <div class="marquee-page marquee-item" #pageElement>
    <div class="marquee-content marquee-item" #contentElement>
      <ng-content></ng-content>
    </div>
  </div>
</div>
